import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  TextField,
  Collapse,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import Alert from "@material-ui/lab/Alert";
import { withAlert } from "react-alert";

import location from "../../stores/locationStore";

const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
  table: {
    minWidth: 650,
  },
  button: {
    margin: 0,
  },
  cardDiv: {
    maxWidth: 500,
  },
  cardBtn: {
    width: "100%",
  },
});

const View = observer(
  class LocationCreate extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        locname: "",
        loc: "",
        IsError: false,
        errorMessage: "",
        btnDisable: false,
        checked: false,
      };
    }
    handleChange = (e) => {
      this.setState({
        [e.target.name]: e.target.value,
      });
    };

    handleSwitch = (e) => {
      this.setState({
        [e.target.name]: e.target.checked,
      });
    };

    handleClick = async () => {
      try {
        this.setState({
          IsError: false,
          btnDisable: true,
        });

        var locname = this.state.locname;
        var loc = this.state.loc;
        if (locname === "" || loc === "") {
          this.setState({
            IsError: true,
            errorMessage: "입력필드를 확인해주세요.",
            btnDisable: false,
          });
          return;
        }
        await location.makeLocation(locname, loc);
        this.setState({
          btnDisable: false,
          locname: "",
          loc: "",
        });
        this.props.alert.show("생성되었습니다.");
      } catch (error) {
        this.setState({
          locname: "",
          loc: "",
          IsError: true,
          btnDisable: false,
          errorMessage: error.message,
        });
      }
    };

    render() {
      const { classes } = this.props;
      return (
        <div>
          <FormControlLabel
            control={
              <Switch
                checked={this.state.checked}
                onChange={this.handleSwitch}
                name="checked"
                color="primary"
              />
            }
            label="기관 등록"
          />
          <Collapse in={this.state.checked}>
            <div className={classes.cardDiv}>
              <Card elevation={5}>
                <CardHeader title="기관 등록" />
                <CardContent>
                  <Typography variant="body1" component="p">
                    아래내용은 전부 입력해주세요. 중복되지 않습니다. <br />
                  </Typography>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="locname"
                    label="기관이름"
                    type="text"
                    id="locname"
                    autoComplete="current-password"
                    value={this.state.locname}
                    onChange={this.handleChange}
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="loc"
                    label="기관코드"
                    type="text"
                    id="loc"
                    autoComplete="current-password"
                    value={this.state.loc}
                    onChange={this.handleChange}
                  />
                  <Collapse in={this.state.IsError}>
                    <Alert severity="error" className={classes.error}>
                      {this.state.errorMessage}
                    </Alert>
                  </Collapse>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classes.cardBtn}
                    onClick={this.handleClick}
                    disabled={this.state.btnDisable}
                  >
                    등록하기
                  </Button>
                </CardActions>
              </Card>
            </div>
          </Collapse>
        </div>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
